import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, CanActivateChild, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoJsService } from '../services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class JEGuardGuard implements CanActivateChild {
  
  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isJELogin = loginDetails.get('isJE') ? loginDetails.get('isJE') : null;
    const isCJELogin = loginDetails.get('isCJE') ? loginDetails.get('isCJE') : null;
    const isJEEWLogin = loginDetails.get('isJEEW') ? loginDetails.get('isJEEW') : null;

    if (isJELogin == '1' || isCJELogin === '1' || isJEEWLogin === '1') {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
